// MASIQ — scroll-reveal motion controller.
// Progressive enhancement: without this script, [data-masiq-reveal]
// elements remain fully visible (see masiq-motion.css). Only once this
// module runs do we flag html.masiq-motion-ready and start observing.
(function () {
  'use strict';

  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    return;
  }

  var reduceMotionQuery = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;
  var prefersReducedMotion = !!(reduceMotionQuery && reduceMotionQuery.matches);

  var root = document.documentElement;
  root.classList.add('masiq-motion-ready');

  var targets = document.querySelectorAll('[data-masiq-reveal]');
  if (!targets.length) {
    return;
  }

  if (prefersReducedMotion) {
    // Reveal instantly, no observer needed; CSS also hard-disables motion.
    targets.forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.12,
    }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
